"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Timeout = _ref => {
  var {
    submit
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "You\u2019ve surpassed the set amount of time for answering the questions. Please try submitting the request again."), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    onClick: submit
  }, "Close"));
};
var _default = exports.default = Timeout;